// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__1zENM"};